import { render, staticRenderFns } from "./contract-content.vue?vue&type=template&id=7b5d03f7"
import script from "./contract-content.vue?vue&type=script&lang=js"
export * from "./contract-content.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b5d03f7')) {
      api.createRecord('7b5d03f7', component.options)
    } else {
      api.reload('7b5d03f7', component.options)
    }
    module.hot.accept("./contract-content.vue?vue&type=template&id=7b5d03f7", function () {
      api.rerender('7b5d03f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/compliance/contractManager/dialog/contract-content.vue"
export default component.exports